export default __webpack_public_path__ + "static/media/CP1.242f86cf.png";